import axios from "axios";
import { serviceUrls } from "./constant";
import {STUDENT_STORAGE_KEYS} from "./student-Services";
const filterNullValues = (obj) => {
  if (!obj || typeof obj !== "object") return obj;

  return Object.fromEntries(
    Object.entries(obj).filter(
      ([_, v]) => v !== null && v !== undefined && v !== ""
    )
  );
};

const apiRequest = async ({
  method,
  url,
  data,
  params,
  pathParams,
  includeOrgHeaders = false,
}) => {
  try {
    if (pathParams) {
      Object.entries(pathParams).forEach(([key, value]) => {
        url = url.replace(`:${key}`, value);
      });
    }
    const fullUrl = url;

    console.log("new url is: ", url);

    // Filter out null values from params and data
    const filteredParams = params ? filterNullValues(params) : undefined;
    const filteredData = data ? filterNullValues(data) : undefined;

    const queryString = filteredParams
      ? `?${new URLSearchParams(filteredParams).toString()}`
      : "";
    console.group("API Request Details");
    console.log("Full URL:", url + queryString);
    console.log("Method:", method);
    if (filteredData)
      console.log("Request Body:", JSON.stringify(filteredData, null, 2));
    console.groupEnd();

    // Base headers

   
    const headers = {
      Authorization: `Bearer ${getLocalStorageData("accessToken")}`,
      "request-from": "WEB",
    };

    // Add organization-specific headers if requested
    if (includeOrgHeaders) {
      const profileDetails = getLocalStorageData("profileDetails");
      if (profileDetails) {
        if (profileDetails["_USER_ID"]) {
          headers["USER-ID"] = profileDetails["_USER_ID"];
        }
        if (profileDetails["_SITE"]) {
          headers["SITE-ID"] = profileDetails["_SITE"];
        }
        if (
          profileDetails["_ORGANIZATION_"] &&
          profileDetails["_ORGANIZATION_"]["_ID"]
        ) {
          headers["ORGANIZATION-ID"] = profileDetails["_ORGANIZATION_"]["_ID"];
        }
        if (profileDetails["_REGION"]) {
          headers["REGION-ID"] = profileDetails["_REGION"];
        }
      }
    }

    const timeout = process.env.REACT_APP_BACKEND_CONNECTION_TIMEOUT;
    const response = await axios({
      method,
      url: fullUrl,
      headers,
      data: filteredData,
      params: filteredParams,
      timeout: timeout,
    });
    console.log(response.config.url, "response");
    return handleResponse(response, {
      method,
      url,
      body: filteredData,
      params: filteredParams,
      pathParams,
    });
  } catch (error) {
    console.log(error, "error");
    console.log(error.response, "error.response");
    if (error.response) {
      return handleResponse(error.response, {
        method,
        url,
        body: data,
        params,
        pathParams,
      });
    } else {
      console.error("Request failed:", error.config?.url);
      return {
        status: "error",
        message: error.message || "An unexpected error occurred",
      };
    }
  }
};

export const get = ({ url, params, includeOrgHeaders = false } = {}) =>
  apiRequest({ method: "GET", url, params, includeOrgHeaders });
export const post = ({
  url,
  data,
  pathParams,
  includeOrgHeaders = false,
} = {}) =>
  apiRequest({ method: "POST", url, data, pathParams, includeOrgHeaders });
export const put = ({ url, data, params, includeOrgHeaders = false } = {}) =>
  apiRequest({ method: "PUT", url, data, params, includeOrgHeaders });
export const patch = ({ url, params, includeOrgHeaders = false } = {}) =>
  apiRequest({ method: "PATCH", url, params, includeOrgHeaders });
export const del = ({ url, params, includeOrgHeaders = false } = {}) =>
  apiRequest({ method: "DELETE", url, params, includeOrgHeaders });

export const createQueryParams = (params = {}) => {
  const cleaned = Object.fromEntries(
    Object.entries(params).filter(
      ([_, v]) => v !== null && v !== undefined && v !== ""
    )
  );

  if (!cleaned.organizationId) {
    const profileDetails = getLocalStorageData("profileDetails");
    if (
      profileDetails &&
      profileDetails["_ORGANIZATION_"] &&
      profileDetails["_ORGANIZATION_"]["_ID"]
    ) {
      cleaned.organizationId = profileDetails["_ORGANIZATION_"]["_ID"];
    }
  }
  return cleaned;
};

const handleResponse = (
  response,
  { method, url, body, params, pathParams }
) => {
  const { status, data } = response;
  switch (status) {
    case 200:
      return { status: "success", data: data.response };
    case 201:
      return { status: "success", data: data.response };
    case 202:
      return { status: "success", message: "Accepted" };
    case 204:
      return { status: "success", message: "No content" };
    case 400:
      return { status: "fail", message: "Bad request", errors: data.errors };
    case 401:
      // Handling of refresh token if access token is expired
      if (data?.errors?.failures) {
        data.errors.failures.forEach((failure) => {
          if ("AU005" === failure.code) {
            const tokenRefreshed = refreshToken();
            if (tokenRefreshed) {
              return apiRequest({
                method,
                url,
                data: body,
                params,
                pathParams,
              });
            }
          }
        });
      }
      return {
        status: "fail",
        message: "Unauthorized",
        errors: data.errors,
        statusCode: 401,
      };
    case 403:
      return {
        status: "fail",
        message: "Forbidden",
        errors: data.errors,
        statusCode: 403,
      };
    case 404:
      return {
        status: "fail",
        message: "Not found",
        errors: data.errors,
        statusCode: 404,
      };
    case 409:
      return { status: "fail", message: "Conflict", errors: data.errors };
    case 500:
      return { status: "error", message: "Server error", errors: data.errors };
    default:
      return { status: "error", message: "Unexpected response", data };
  }
};

export const getLocalStorageData = (key) => {
  // Check if user is a student by checking both possible storage locations
  console.log("Fetching data for key:", key);
  const isStudentFromRegular = localStorage.getItem("isStudent") === "true";
  const isStudentFromStudentKeys =
    localStorage.getItem(STUDENT_STORAGE_KEYS.isStudent) === "true";
  const isStudent = isStudentFromRegular || isStudentFromStudentKeys;

  if (isStudent) {
    // Map regular keys to student keys
    const keyMapping = {
      accessToken: STUDENT_STORAGE_KEYS.ACCESS_TOKEN,
      refreshToken: STUDENT_STORAGE_KEYS.REFRESH_TOKEN,
      profileDetails: STUDENT_STORAGE_KEYS.PROFILE_DETAILS,
      isStudent: STUDENT_STORAGE_KEYS.isStudent,
    };

    // Use student key if mapping exists, otherwise use the original key
    const studentKey = keyMapping[key] || key;
    const data = localStorage.getItem(studentKey);
    return key == "profileDetails" ? JSON.parse(data) : data;
  } else {
    // Use regular keys for non-student users
    const data = localStorage.getItem(key);
  return key == "profileDetails" ? JSON.parse(data) : data;
  }
};


const refreshToken = async () => {
  try {
    const data = {
      refreshToken: getLocalStorageData("refreshToken"),
    };

    const response = await post({
      url: serviceUrls.ADMIN_SERVICE + "/open/refresh",
      data: data,
    });

    if (response.status === "success") {
      // Check if user is a student to determine which keys to update
      const isStudentFromRegular = localStorage.getItem("isStudent") === "true";
      const isStudentFromStudentKeys =
        localStorage.getItem(STUDENT_STORAGE_KEYS.isStudent) === "true";
      const isStudent = isStudentFromRegular || isStudentFromStudentKeys;

      if (isStudent) {
        // Update student tokens
        localStorage.setItem(
          STUDENT_STORAGE_KEYS.ACCESS_TOKEN,
          response.data.accessToken
        );
        localStorage.setItem(
          STUDENT_STORAGE_KEYS.REFRESH_TOKEN,
          response.data.refreshToken
        );
        console.log("Student tokens refreshed");
      } else {
        // Update regular tokens
        localStorage.setItem("accessToken", response.data.accessToken);
        localStorage.setItem("refreshToken", response.data.refreshToken);
        console.log("Regular tokens refreshed");
      }

      return true;
    }
  } catch (error) {
    console.log(error.response, "error.response");
  }
  return false;
};
